export const ROLE_ADMIN = 'admin'
export const ROLE_VIEWER = 'viewer'

export const ROLES = Object.freeze([ROLE_ADMIN, ROLE_VIEWER])
